import { render, staticRenderFns } from "./LoginGestaoConta.vue?vue&type=template&id=2912a90f"
import script from "./LoginGestaoConta.vue?vue&type=script&lang=js"
export * from "./LoginGestaoConta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports